export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/email_marketing.6526314.svg";